import { OrganizationRank } from "src/data/organizations/types/organizationMemberTypes"
import { TOrganizationRole } from "src/data/organizations/types/organizationMemberTypes"

/** Get the access rank of a role */
export function getOrgAccessRank(
  role: TOrganizationRole | undefined
): OrganizationRank {
  if (role === undefined) {
    return OrganizationRank.MINIMUM
  }

  switch (role) {
    case "owner":
      return OrganizationRank.OWNER
    case "admin":
      return OrganizationRank.ADMIN
    case "member":
      return OrganizationRank.MEMBER
    case "operator":
      return OrganizationRank.OPERATOR
    case "minimum":
      return OrganizationRank.MINIMUM
    default: {
      const _exhaustive: never = role // Throws a compile time error if a case is missing
      return OrganizationRank.MINIMUM
    }
  }
}

/** @deprecated check `accessLogic.ts` module for appropriate function */
export function hasOrgAccess(
  role: TOrganizationRole | undefined,
  minLevel: TOrganizationRole = "admin"
): boolean {
  if (role === undefined) {
    return false
  }
  const rank = getOrgAccessRank(role)
  const minRank = getOrgAccessRank(minLevel)
  return rank >= minRank
}
